import ReactDOM from 'react-dom';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import styles from './styles.less';

const metaTags = [
    { charset: 'utf-8' },
    { 'http-equiv': 'Content-Language', content: 'en' },
    { 'http-equiv': 'X-UA-Compatible', content: 'IE=edge' },
    { name: 'apple-mobile-web-app-capable', content: 'yes' },
    { name: 'apple-mobile-web-app-status-bar-style', content: 'black-translucent' },
    {
        name: 'viewport',
        content: 'width=device-width, minimum-scale=1, maximum-scale=1, user-scalable=no'
    }
];

//FIXME dataset name/description not propagating in
function App({ params = {}, children = [], view={} } = {}, b) {
 
    const { client, dataset, session } = params;

    const pageTitle = (((view||{}).scene||{}).page||{}).title;
    const favicon = (((view||{}).scene||{}).page||{}).favicon || "/static/assets/images/ico/graphistry-favicon.ico";

    const titleTemplate = pageTitle ? pageTitle : `%s - Graphistry's Graph Explorer`;
    const defaultTitle = `Graphistry visualization`;
    const title = `${dataset || session || ''}${client === 'static' ? ' (exported)' : ''}`;

    return (
        <HelmetProvider>
            <div className={styles['app']}>
                <Helmet
                    meta={metaTags}
                    title={title}
                    defaultTitle={defaultTitle}
                    titleTemplate={titleTemplate}
                >
                    <link rel="shortcut icon" href={favicon}/>
                </Helmet>
                {children}
            </div>
        </HelmetProvider>
    );
}

export { App };
export default App;